import { render, staticRenderFns } from "./OfficialWebsiteBottom.vue?vue&type=template&id=7c98572a&scoped=true"
import script from "./OfficialWebsiteBottom.vue?vue&type=script&lang=js"
export * from "./OfficialWebsiteBottom.vue?vue&type=script&lang=js"
import style0 from "./OfficialWebsiteBottom.vue?vue&type=style&index=0&id=7c98572a&prod&lang=scss&scoped=true"
import style1 from "./OfficialWebsiteBottom.vue?vue&type=style&index=1&id=7c98572a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c98572a",
  null
  
)

export default component.exports